import React, { Component } from "react";
import { auth } from "../../common/helpers/auth";
import { Growl } from "primereact/components/growl/Growl";

class Register extends Component {
  state = { email: "", password: "", confirmPassword: "" };

  handleSubmitRegister = () => {
    this.growl.clear();
    if (this.state.password === this.state.confirmPassword) {
      auth(this.state.email, this.state.password)
        .then(() => {
          this.growl.show({
            severity: "success",
            summary: <br />,
            detail: "Success: The user was registered.",
            life: 3000
          });
        })
        .catch(error => {
          this.growl.show({
            severity: "error",
            summary: <br />,
            detail: error.toString(),
            life: 3000
          });
        });
    } else {
      this.growl.show({
        severity: "error",
        summary: <br />,
        detail: "Error: The password does not match the confirm password.",
        life: 3000
      });
    }
  };

  handleKeyPress = e => {
    if (e.key === "Enter") {
      this.handleSubmitRegister();
    }
  };

  render() {
    return (
      <div className="login-page" onKeyPress={this.handleKeyPress}>
        <div className="ui-g">
          <div className="card login-panel ui-fluid">
            <Growl
              style={{ textAlign: "left" }}
              ref={el => (this.growl = el)}
            />
            <div className="ui-g">
              <div className="ui-g-12">
                <img
                  src="/assets/layout/images/bpp/bpp-logo.png"
                  alt="Belfast Pilates & Physiotherapy - Specialising in Physio led Pilates"
                  height="100%"
                  width="100%"
                />
              </div>
              <div className="ui-g-12">
                <span className="md-inputfield">
                  <input
                    className={
                      this.state.email === ""
                        ? "ui-inputtext"
                        : "ui-inputtext ui-state-filled"
                    }
                    type="email"
                    value={this.state.email}
                    onChange={e => this.setState({ email: e.target.value })}
                  />
                  <label>Email Address</label>
                </span>
              </div>
              <div className="ui-g-12">
                <span className="md-inputfield">
                  <input
                    className={
                      this.state.password === ""
                        ? "ui-inputtext"
                        : "ui-inputtext ui-state-filled"
                    }
                    type="password"
                    value={this.state.password}
                    onChange={e => this.setState({ password: e.target.value })}
                  />
                  <label>Password</label>
                </span>
              </div>
              <div className="ui-g-12">
                <span className="md-inputfield">
                  <input
                    className={
                      this.state.confirmPassword === ""
                        ? "ui-inputtext"
                        : "ui-inputtext ui-state-filled"
                    }
                    type="password"
                    value={this.state.confirmPassword}
                    onChange={e =>
                      this.setState({ confirmPassword: e.target.value })
                    }
                  />
                  <label>Confirm Password</label>
                </span>
              </div>
              <div className="ui-g-12">
                <button className="ui-button ui-button-text-icon-left">
                  <span className="ui-button-icon-left ui-icon-person-add" />
                  <span
                    className="ui-button-text"
                    onClick={this.handleSubmitRegister}
                  >
                    Register
                  </span>
                </button>
                <span className="ui-float-label">
                  <a href="#/">Already Registered?</a>
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default Register;



// WEBPACK FOOTER //
// ./src/components/Register/Register.js